import React from 'react'
import PropTypes from 'prop-types'
import Label from '../Atoms/Label'
import Text from '../Atoms/Text'
import i18n from '../../../Utils/I18nUtil'
import styled from 'styled-components'

const InputText = ({label, id, value, onChange, color}) => {
    return (
        <Wrapper>
            <Label
                htmlFor={id}
                color={color}>
                {i18n(label)}
            </Label>
            <Text
                id={id}
                value={value}
                onChange={onChange}
                borderColor={'#d9e2e9'}/>
        </Wrapper>
    )
}

InputText.propTypes = {
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    color: PropTypes.string,
}

export default InputText

const Wrapper = styled.div`
    &:not(:first-of-type) { 
        margin-top: 15px;
   } 
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Molecules/InputText.jsx